(function () {
  'use strict';

  var POLL_INTERVAL_MS = 2500;

  function apiBase(root) {
    return (root.dataset.apiBase || window.MIGRATION_API_BASE || '').replace(/\/$/, '');
  }

  async function request(root, path, options) {
    options = options || {};
    var response = await fetch(apiBase(root) + path, Object.assign({}, options, {
      headers: Object.assign({
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true'
      }, options.headers || {})
    }));
    var body = await response.json().catch(function () { return {}; });

    if (!response.ok) {
      throw new Error(body.error || ('Request failed (' + response.status + ')'));
    }

    return body;
  }

  function wait(ms) {
    return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
  }

  function text(value, fallback) {
    if (value == null || value === '') return fallback || 'Unavailable';
    if (Array.isArray(value)) return value.map(function (item) { return text(item, ''); }).filter(Boolean).join(', ') || (fallback || 'Unavailable');
    if (typeof value === 'object') return fallback || 'Available';
    return String(value);
  }

  function money(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return '$0';
    return '$' + Math.round(number).toLocaleString('en-US');
  }

  function moneyPrecise(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return '$0.00';
    return '$' + number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function element(tag, className, content) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (content != null) node.textContent = content;
    return node;
  }

  function append(parent) {
    for (var i = 1; i < arguments.length; i += 1) {
      var child = arguments[i];
      if (child != null) parent.appendChild(child);
    }
    return parent;
  }

  function clearNode(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
    return node;
  }

  function safeHref(value) {
    try {
      var url = new URL(value, window.location.origin);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
    } catch (_error) {
      return '';
    }
  }

  function link(label, href, className) {
    var node = element('a', className, label);
    var safeUrl = safeHref(href);
    if (safeUrl) {
      node.href = safeUrl;
      node.target = '_blank';
      node.rel = 'noopener';
    }
    return node;
  }

  function apiHref(root, path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(String(path))) return safeHref(path);
    return safeHref(apiBase(root) + path);
  }

  function progressMessage(status) {
    return {
      pending: 'Preparing your migration strategy...',
      analyzing: 'Analyzing platform, revenue, effort, and cost...',
      teaser_ready: 'Migration strategy ready'
    }[status] || 'Building your migration strategy...';
  }

  function normalizeRevenue(value) {
    var number = Number(String(value || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(number) && number > 0 ? Math.round(number) : 0;
  }

  function metric(label, value) {
    return append(
      element('div', 'wc-migration-results__metric'),
      element('span', '', label),
      element('strong', '', value)
    );
  }

  function renderScan(parent, audit) {
    var teaser = audit.teaser || {};
    var scan = element('section', 'wc-migration-results__scan');
    var source = element('p', 'wc-migration-results__source');
    append(source, document.createTextNode('Migration strategy for '), link(text(audit.storeUrl), audit.storeUrl));

    append(
      scan,
      append(
        element('div', 'wc-migration-results__scan-head'),
        append(element('div'), element('p', 'wc-migration-results__label', 'Shopify migration scan'), source),
        append(
          element('div', 'wc-migration-results__score'),
          element('p', 'wc-migration-results__label', 'Effort'),
          element('strong', '', text(teaser.effort, 'Medium'))
        )
      ),
      append(
        element('div', 'wc-migration-results__metrics'),
        metric('Current platform', text(teaser.currentPlatform || audit.currentPlatform)),
        metric('Revenue band', text(teaser.revenueBand)),
        metric('Recommended plan', text(teaser.recommendedPlan)),
        metric('Timeline', text(teaser.estimatedTimeline))
      )
    );

    parent.appendChild(scan);
  }

  function renderTeaser(parent, audit) {
    var teaser = audit.teaser || {};
    var section = append(element('section', 'wc-migration-results__section'), element('h2', 'wc-migration-results__section-title', 'Migration strategy preview'));
    var grid = element('div', 'wc-migration-results__grid');

    (teaser.topLimitations || []).forEach(function (item) {
      grid.appendChild(append(
        element('article', 'wc-migration-results__signal'),
        element('h3', '', text(item.limitation, 'Platform limitation')),
        element('p', '', text(item.shopifySolution, 'Shopify reduces this migration risk.'))
      ));
    });

    if (!grid.children.length) {
      grid.appendChild(append(
        element('article', 'wc-migration-results__signal'),
        element('h3', '', 'Plan ready'),
        element('p', '', 'Unlock the full report to view cost, transfer scope, and checklist details.')
      ));
    }

    section.appendChild(grid);
    parent.appendChild(section);
  }

  function renderList(parent, items, emptyText) {
    items = Array.isArray(items) ? items : [];
    if (!items.length) {
      parent.appendChild(element('p', '', emptyText || 'No items available.'));
      return;
    }

    var list = element('ol', 'wc-migration-results__list');
    items.forEach(function (item) {
    list.appendChild(element('li', '', text(item)));
    });
    parent.appendChild(list);
  }

  function renderDataTable(parent, title, columns, rows) {
    rows = Array.isArray(rows) ? rows : [];
    if (!rows.length) return;

    var section = append(element('section', 'wc-migration-results__report'), element('h2', 'wc-migration-results__section-title', title));
    var wrap = element('div', 'wc-migration-results__table-wrap');
    var table = element('table', 'wc-migration-results__data-table');
    var thead = element('thead');
    var headRow = element('tr');
    columns.forEach(function (column) {
      headRow.appendChild(element('th', '', column.label));
    });
    thead.appendChild(headRow);
    table.appendChild(thead);

    var tbody = element('tbody');
    rows.forEach(function (row) {
      var tableRow = element('tr');
      columns.forEach(function (column) {
        tableRow.appendChild(element('td', '', text(row[column.key], '')));
      });
      tbody.appendChild(tableRow);
    });
    table.appendChild(tbody);
    wrap.appendChild(table);
    section.appendChild(wrap);
    parent.appendChild(section);
  }

  function renderComparison(parent, comparison) {
    comparison = Array.isArray(comparison) ? comparison : [];
    if (!comparison.length) return;

    var section = append(element('section', 'wc-migration-results__report'), element('h2', 'wc-migration-results__section-title', 'Current platform vs Shopify'));
    var rows = element('div', 'wc-migration-results__comparison');
    comparison.forEach(function (item) {
      rows.appendChild(append(
        element('article', 'wc-migration-results__comparison-row'),
        append(element('div'), element('span', '', 'Area'), element('p', '', text(item.area))),
        append(element('div'), element('span', '', 'Now'), element('p', '', text(item.current))),
        append(element('div'), element('span', '', 'Shopify'), element('p', '', text(item.shopify))),
        append(element('div'), element('span', '', 'Why it matters'), element('p', '', text(item.relevance)))
      ));
    });
    section.appendChild(rows);
    parent.appendChild(section);
  }

  function renderCost(parent, report) {
    var current = report.currentCost || {};
    var shopify = report.shopifyCost || {};
    var diff = report.financialDifference || {};
    var plan = report.recommendedShopifyPlan || {};
    var section = append(element('section', 'wc-migration-results__report'), element('h2', 'wc-migration-results__section-title', '12-month cost comparison'));
    append(
      section,
      append(
        element('div', 'wc-migration-results__metrics'),
        metric('Current annual cost', money(current.annualTotal)),
        metric('Shopify annual cost', money(shopify.annualTotal)),
        metric('Net difference', money(Math.abs(diff.netDifference || 0))),
        metric('Plan', text(plan.name))
      ),
      element('p', '', text(diff.interpretation, 'Cost model is available in the report.'))
    );
    if (report.migrationEffort && report.migrationEffort.includeMigrationCostInDecision) {
      section.appendChild(element('p', '', 'Material one-time migration cost estimate: ' + text(report.migrationEffort.oneTimeMigrationCost)));
    }
    parent.appendChild(section);
  }

  function renderPricingSources(parent, report) {
    var current = report.currentCost || {};
    var shopify = report.shopifyCost || {};
    var currentPublicFee = current.pricingType === 'quote_required'
      ? 'Custom quote required'
      : money(current.platformSubscriptionMonthly || 0) + '/mo';
    if (current.pricingUnit === 'per_user' && current.publicPlanUnitMonthly != null && current.paidUserCount) {
      currentPublicFee = moneyPrecise(current.publicPlanUnitMonthly) + '/user/mo x ' + current.paidUserCount + ' users = ' + moneyPrecise(current.platformSubscriptionMonthly || 0) + '/mo';
    }
    var rows = [
      {
        side: 'Current platform',
        plan: text(current.selectedPlatformPlan, 'Plan unavailable'),
        publicFee: currentPublicFee,
        source: text(current.pricingSourceName, 'Pricing source unavailable'),
        note: text(current.pricingSourceNote, 'No pricing note returned.')
      },
      {
        side: 'Shopify',
        plan: text(shopify.planName || (report.recommendedShopifyPlan && report.recommendedShopifyPlan.name), 'Shopify plan unavailable'),
        publicFee: money(shopify.planMonthly || 0) + '/mo',
        source: 'Shopify pricing configuration',
        note: text((shopify.assumptions || [])[0], 'Shopify plan pricing is included in the cost model.')
      }
    ];
    renderDataTable(parent, 'Pricing sources used', [
      { label: 'Side', key: 'side' },
      { label: 'Plan', key: 'plan' },
      { label: 'Public platform fee', key: 'publicFee' },
      { label: 'Source', key: 'source' },
      { label: 'Note', key: 'note' }
    ], rows);
  }

  function renderScanEvidence(parent, report) {
    var scan = report.scan || {};
    var sitemap = scan.sitemapSignals || {};
    var confirmation = scan.platformConfirmation || {};
    var rows = [
      {
        signal: 'Platform confirmation',
        detail: text(confirmation.message, 'Platform confirmation was not returned.'),
        action: confirmation.needsReview ? 'Confirm before final migration scoping.' : 'Use as scan-confirmed platform input.'
      },
      {
        signal: 'Detected platform evidence',
        detail: scan.platformEvidence || 'No public platform signature was confirmed.',
        action: scan.platformConfidence ? ('Confidence: ' + scan.platformConfidence) : 'Confirm with admin/export access.'
      },
      {
        signal: 'Platform evidence signals',
        detail: text(scan.platformEvidenceSignals || [], 'No platform markers captured.'),
        action: scan.detectedPlatform ? ('Detected as ' + scan.detectedPlatform) : 'Use selected platform as user-confirmed input.'
      },
      {
        signal: 'Navigation and product families',
        detail: text(scan.productFamilies || scan.navigationLabels || [], 'No crawlable navigation labels captured.'),
        action: 'Use these labels when mapping Shopify collections and menus.'
      },
      {
        signal: 'Homepage links',
        detail: text((scan.productLinkCount || 0) + ' product links, ' + (scan.collectionLinkCount || 0) + ' collection/category links'),
        action: 'Combine homepage evidence with sitemap and Search Console URLs.'
      },
      {
        signal: 'Sitemap sample',
        detail: sitemap.urlCount
          ? text(sitemap.urlCount + ' URLs, ' + (sitemap.productUrlCount || 0) + ' product URLs, ' + (sitemap.collectionUrlCount || 0) + ' collection/category URLs')
          : 'No sitemap URL count captured.',
        action: 'Use sitemap URLs to protect SEO redirects.'
      },
      {
        signal: 'Payment and checkout signals',
        detail: text([].concat(scan.paymentSignals || [], scan.checkoutSignals || []), 'No payment/checkout signatures captured.'),
        action: 'Validate every equivalent in Shopify before launch.'
      },
      {
        signal: 'Third-party technology signals',
        detail: text(scan.technologySignals || [], 'No third-party technology signatures captured.'),
        action: 'Map each retained tool to a Shopify app, pixel, or integration.'
      }
    ];

    renderDataTable(parent, 'Store-specific scan evidence', [
      { label: 'Signal', key: 'signal' },
      { label: 'Observed detail', key: 'detail' },
      { label: 'Migration use', key: 'action' }
    ], rows);
  }

  function renderTransferPlan(parent, transfer) {
    transfer = transfer || {};
    var section = append(element('section', 'wc-migration-results__report'), element('h2', 'wc-migration-results__section-title', 'What transfers and what needs work'));
    section.appendChild(element('h3', '', 'Migrates automatically'));
    renderList(section, transfer.automatic, 'No automatic migration items were returned.');
    section.appendChild(element('h3', '', 'Requires manual work'));
    renderList(section, transfer.manual, 'No manual migration items were returned.');
    section.appendChild(element('h3', '', 'Requires custom solutions'));
    renderList(section, transfer.custom, 'No custom migration items were returned.');
    parent.appendChild(section);
  }

  function renderChecklist(parent, checklist) {
    checklist = checklist || {};
    var section = append(element('section', 'wc-migration-results__report'), element('h2', 'wc-migration-results__section-title', text(checklist.title, 'Migration checklist')));
    var tabs = element('div', 'wc-migration-results__tabs');
    var body = element('div');
    var entries = [
      { label: 'Pre-migration', items: checklist.preMigration || [] },
      { label: 'During migration', items: checklist.duringMigration || [] },
      { label: 'Post-migration', items: checklist.postMigration || [] }
    ];

    function show(index) {
      Array.prototype.forEach.call(tabs.querySelectorAll('button'), function (tab, tabIndex) {
        tab.classList.toggle('wc-migration-results__tab--active', tabIndex === index);
        tab.setAttribute('aria-selected', String(tabIndex === index));
      });
      clearNode(body);
      renderList(body, entries[index].items, 'No checklist items available.');
    }

    entries.forEach(function (entry, index) {
      var tab = element('button', 'wc-migration-results__tab', entry.label);
      tab.type = 'button';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', 'false');
      tab.addEventListener('click', function () { show(index); });
      tabs.appendChild(tab);
    });

    append(section, tabs, body);
    parent.appendChild(section);
    show(0);
  }

  function renderDownloadButton(parent, pdfUrl, apiRoot) {
    var href = apiHref(apiRoot, pdfUrl);
    if (!href) return;

    var actions = element('div', 'wc-migration-results__actions');
    var download = element('a', 'wc-migration-results__button', 'Download PDF');
    download.href = href;
    download.target = '_blank';
    download.rel = 'noopener';
    download.setAttribute('download', '');
    actions.appendChild(download);
    parent.appendChild(actions);
  }

  function renderMarkdownReport(parent, markdown) {
    if (!markdown) return false;

    var section = append(element('section', 'wc-migration-results__report wc-migration-results__markdown'), element('h2', 'wc-migration-results__section-title', 'Generated migration strategy'));
    var lines = String(markdown).replace(/^```(?:markdown|md)?\s*/i, '').replace(/```$/i, '').split(/\r?\n/);
    var index = 0;

    function isMarker(line) {
      return /^<!--(?:DIFFICULTY:|CHECKLIST_START|CHECKLIST_END)/.test(line.trim());
    }

    function isTableStart(position) {
      return lines[position] && /^\s*\|.+\|\s*$/.test(lines[position]) &&
        lines[position + 1] && /^\s*\|?\s*:?-{3,}:?\s*(\|\s*:?-{3,}:?\s*)+\|?\s*$/.test(lines[position + 1]);
    }

    function cells(line) {
      return line.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map(function (cell) {
        return cell.replace(/\\\|/g, '|').trim();
      });
    }

    while (index < lines.length) {
      var line = lines[index].trim();
      if (!line || isMarker(line)) {
        index += 1;
        continue;
      }

      if (isTableStart(index)) {
        var table = element('table', 'wc-migration-results__markdown-table');
        var thead = element('thead');
        var headRow = element('tr');
        cells(lines[index]).forEach(function (cell) {
          headRow.appendChild(element('th', '', cell));
        });
        thead.appendChild(headRow);
        table.appendChild(thead);
        var tbody = element('tbody');
        index += 2;
        while (index < lines.length && /^\s*\|.+\|\s*$/.test(lines[index])) {
          var row = element('tr');
          cells(lines[index]).forEach(function (cell) {
            row.appendChild(element('td', '', cell));
          });
          tbody.appendChild(row);
          index += 1;
        }
        table.appendChild(tbody);
        section.appendChild(table);
        continue;
      }

      if (/^###\s+/.test(line)) {
        section.appendChild(element('h3', '', line.replace(/^###\s+/, '')));
        index += 1;
        continue;
      }

      if (/^##\s+/.test(line)) {
        section.appendChild(element('h3', '', line.replace(/^##\s+/, '')));
        index += 1;
        continue;
      }

      if (/^-\s+/.test(line)) {
        var list = element('ul', 'wc-migration-results__list');
        while (index < lines.length && /^-\s+/.test(lines[index].trim())) {
          var item = lines[index].trim().replace(/^-\s+/, '');
          var li = element('li');
          if (/^\[[ xX]\]\s+/.test(item)) {
            var checkbox = element('input');
            checkbox.type = 'checkbox';
            checkbox.disabled = true;
            checkbox.checked = /^\[[xX]\]/.test(item);
            append(li, checkbox, document.createTextNode(' ' + item.replace(/^\[[ xX]\]\s+/, '')));
          } else {
            li.textContent = item;
          }
          list.appendChild(li);
          index += 1;
        }
        section.appendChild(list);
        continue;
      }

      section.appendChild(element('p', '', line));
      index += 1;
    }

    parent.appendChild(section);
    return true;
  }

  function renderFullReport(parent, report, pdfUrl, apiRoot) {
    report = report || {};
    var overview = append(element('section', 'wc-migration-results__report'), element('h2', 'wc-migration-results__section-title', 'Shopify migration strategy'));
    append(
      overview,
      element('p', '', text(report.stakeholderSummary, 'Migration summary is available.')),
      append(
        element('div', 'wc-migration-results__metrics'),
        metric('Effort', text(report.migrationEffort && report.migrationEffort.rating)),
        metric('Timeline', text(report.migrationEffort && report.migrationEffort.timeline)),
        metric('Product count', text(report.estimatedProductCount)),
        metric('Revenue band', text(report.revenueBand))
      )
    );
    if (report.estimatedProductCountSource) {
      overview.appendChild(element('p', '', text(report.estimatedProductCountSource)));
    }
    parent.appendChild(overview);
    renderDownloadButton(parent, pdfUrl, apiRoot);
    if (renderMarkdownReport(parent, report.markdownReport)) {
      return;
    }
    renderScanEvidence(parent, report);
    renderCost(parent, report);
    renderPricingSources(parent, report);
    renderComparison(parent, report.comparison);
    renderDataTable(parent, 'Detected current platform limitations', [
      { label: 'Limitation', key: 'limitation' },
      { label: 'Why it matters', key: 'whyItMatters' },
      { label: 'Shopify solution', key: 'shopifySolution' }
    ], report.platformLimitations);
    renderDataTable(parent, 'How Shopify fixes those limitations', [
      { label: 'Current limitation', key: 'currentLimitation' },
      { label: 'Shopify capability', key: 'shopifyCapability' },
      { label: 'Implementation step', key: 'implementationStep' },
      { label: 'Residual risk', key: 'residualRisk' }
    ], report.platformLimitationFixes);
    renderDataTable(parent, 'Shopify limitations and mitigation', [
      { label: 'Shopify limitation', key: 'limitation' },
      { label: 'Impact', key: 'impact' },
      { label: 'Mitigation', key: 'mitigation' }
    ], report.shopifyLimitations);
    renderDataTable(parent, 'Shopify store structure', [
      { label: 'Area', key: 'area' },
      { label: 'Shopify structure', key: 'shopifyStructure' },
      { label: 'Current platform mapping', key: 'currentPlatformMapping' },
      { label: 'Migration notes', key: 'migrationNotes' }
    ], report.shopifyStoreStructure);
    renderTransferPlan(parent, report.transferPlan);
    renderDataTable(parent, 'Current platform and Shopify checklist', [
      { label: 'Phase', key: 'phase' },
      { label: 'Current platform task', key: 'currentPlatformTask' },
      { label: 'Shopify task', key: 'shopifyTask' },
      { label: 'Owner', key: 'owner' },
      { label: 'Risk if skipped', key: 'riskIfSkipped' }
    ], report.checklistTable);
    renderChecklist(parent, report.checklist);
  }

  function renderUnlockGate(parent, audit, onUnlock, apiRoot) {
    if (audit.unlocked || audit.fullReport) {
      renderFullReport(parent, audit.fullReport, audit.pdfUrl, apiRoot);
      return;
    }

    var section = append(
      element('section', 'wc-migration-results__report wc-migration-results__unlock'),
      element('h2', 'wc-migration-results__section-title', 'Unlock the full migration strategy'),
      element('p', '', 'Enter your details to reveal the full migration report, download the PDF, and notify Slack with this lead.')
    );
    var form = element('form', 'wc-migration-results__unlock-form');
    var email = element('input');
    email.type = 'email';
    email.name = 'email';
    email.autocomplete = 'email';
    email.placeholder = 'Work email';
    email.required = true;
    email.setAttribute('aria-label', 'Email address');

    var phone = element('input');
    phone.type = 'tel';
    phone.name = 'phone';
    phone.autocomplete = 'tel';
    phone.placeholder = 'Phone number';
    phone.required = true;
    phone.setAttribute('aria-label', 'Phone number');

    var submit = element('button', 'wc-migration-results__button', 'Unlock strategy');
    submit.type = 'submit';
    var message = element('p', 'wc-migration-results__unlock-message');
    append(form, email, phone, submit, message);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (form.reportValidity && !form.reportValidity()) return;
      submit.disabled = true;
      submit.textContent = 'Unlocking strategy...';
      message.textContent = '';

      try {
        var auditId = audit.migrationAuditId || audit.auditId || audit.id;
        var response = await request(apiRoot, '/api/migration/audits/' + encodeURIComponent(auditId) + '/unlock', {
          method: 'POST',
          body: JSON.stringify({ email: email.value.trim(), phone: phone.value.trim() })
        });
        if (!response.unlocked && !response.fullReport) {
          throw new Error('The server did not confirm the migration strategy was unlocked.');
        }
        onUnlock(response);
      } catch (error) {
        message.textContent = error.message || 'Unable to unlock the migration strategy.';
        submit.disabled = false;
        submit.textContent = 'Unlock strategy';
      }
    });

    section.appendChild(form);
    parent.appendChild(section);
  }

  function renderResults(resultsRoot, content, cta, audit) {
    clearNode(content);
    var inner = element('div', 'wc-migration-results__inner');
    var isUnlocked = Boolean(audit.unlocked || audit.fullReport);
    var hero = append(
      element('div', 'wc-migration-results__hero'),
      element('p', 'wc-migration-results__eyebrow', isUnlocked ? 'Shopify migration plan' : 'Migration strategy ready'),
      element('h1', '', isUnlocked ? 'Your Shopify migration strategy is ready' : 'Your migration plan is ready')
    );
    var back = element('a', 'wc-migration-results__back');
    back.href = resultsRoot.dataset.auditAgainUrl || window.location.pathname;
    append(back, element('span', '', 'Back'), document.createTextNode(' ' + text(resultsRoot.dataset.auditAgainLabel, 'Plan another migration')));

    append(inner, hero, back);
    renderScan(inner, audit);
    renderTeaser(inner, audit);
    renderUnlockGate(inner, audit, function (response) {
      audit.unlocked = true;
      audit.fullReport = response.fullReport;
      audit.pdfUrl = response.pdfUrl || audit.pdfUrl;
      renderResults(resultsRoot, content, cta, audit);
    }, resultsRoot);

    content.appendChild(inner);
    if (cta) cta.hidden = !isUnlocked;
    resultsRoot.hidden = false;
  }

  function isAuditReady(audit) {
    if (!audit) return false;
    var status = String(audit.status || '').toLowerCase();
    return status === 'teaser_ready' || status === 'ready' || status === 'completed' || Boolean(audit.teaser);
  }

  async function pollAudit(root, auditId, onProgress) {
    var audit;
    do {
      await wait(POLL_INTERVAL_MS);
      audit = await request(root, '/api/migration/audits/' + encodeURIComponent(auditId));
      if (audit.status === 'failed') throw new Error(audit.error || 'Migration audit failed.');
      onProgress(progressMessage(audit.status));
    } while (!isAuditReady(audit));
    return audit;
  }

  function showFormMessage(root, form, messageText, isError) {
    var node = root.querySelector('[data-wc-migration-form-message]');
    if (!node) {
      node = element('p', 'wc-migration__form-message');
      node.setAttribute('data-wc-migration-form-message', '');
      form.insertAdjacentElement('afterend', node);
    }
    node.textContent = messageText;
    node.hidden = false;
    node.classList.toggle('wc-migration__form-message--error', Boolean(isError));
    return node;
  }

  function initialize(root) {
    root = root || document;
    var form = root.querySelector('[data-wc-migration-audit-form]');
    if (!form || form.dataset.wcMigrationBound === 'true') return;
    form.dataset.wcMigrationBound = 'true';

    var message = root.querySelector('[data-wc-migration-form-message]');
    var loading = root.querySelector('[data-wc-migration-loading]');
    var loadingMessage = root.querySelector('[data-wc-migration-loading-message]');
    var input = root.querySelector('[data-wc-migration-input]');
    var results = root.querySelector('[data-wc-migration-results]');
    var content = root.querySelector('[data-wc-migration-results-content]');
    var cta = root.querySelector('[data-wc-migration-results-cta]');
    if (!message) message = showFormMessage(root, form, '', false);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (form.reportValidity && !form.reportValidity()) return;

      var submit = form.querySelector('button[type="submit"]');
      var storeUrl = form.elements.store_url ? form.elements.store_url.value.trim() : '';
      var platform = form.elements.platform ? form.elements.platform.value : '';
      var annualRevenue = normalizeRevenue(form.elements.annual_revenue ? form.elements.annual_revenue.value : '');
      if (!annualRevenue) {
        showFormMessage(root, form, 'Please enter annual revenue.', true);
        return;
      }
      if (!results || !content) {
        showFormMessage(root, form, 'Migration results container is missing from this Shopify section.', true);
        return;
      }

      if (submit) submit.disabled = true;
      message.hidden = true;
      message.classList.remove('wc-migration__form-message--error');
      form.hidden = true;
      results.hidden = true;
      clearNode(content);
      if (cta) cta.hidden = true;
      if (loading) loading.hidden = false;
      if (loadingMessage) loadingMessage.textContent = 'Building your Shopify migration strategy...';

      try {
        var started = await request(root, '/api/migration/audits', {
          method: 'POST',
          body: JSON.stringify({
            url: storeUrl,
            platform: platform,
            annualRevenue: annualRevenue
          })
        });
        var auditId = started.migrationAuditId || started.auditId || started.id;
        if (!auditId) throw new Error('The migration API did not return an audit id.');

        var audit = await pollAudit(root, auditId, function (copy) {
          if (loadingMessage) loadingMessage.textContent = copy;
        });

        if (loading) loading.hidden = true;
        if (input) input.hidden = true;
        results.hidden = false;
        renderResults(results, content, cta, audit);
      } catch (error) {
        if (loading) loading.hidden = true;
        form.hidden = false;
        message.textContent = error.message || 'Unable to generate the migration strategy right now.';
        message.classList.add('wc-migration__form-message--error');
        message.hidden = false;
        if (submit) submit.disabled = false;
      }
    });
  }

  function initializeAll() {
    document.querySelectorAll('[data-wc-migration-audit]').forEach(initialize);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-wc-migration-audit-form]');
    if (!form || form.dataset.wcMigrationBound === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    initialize(form.closest('[data-wc-migration-audit]') || document);
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
}());
